import reportService from "@/services/report";

/**
 * Radnici firme tipa "grupa" za izveštaj "Pregled korisnika". Stari tab (CompanyReportTabEmployee) ih ne učitava
 * sam, nego dobija `users` i `loading` (kao u staroj stranici group.vue), pa ih ljuska učitava umesto njega.
 * Ljuska mora da ima hasCompanyReportState (ready, selectedCompanyIds, from, to) i računato svojstvo
 * `feedsGroupUsers` (true kad je otvoren izveštaj kojem trebaju radnici). Učitava se samo tada, za izabrane firme
 * i period; zastareli odgovori se ignorišu.
 */
export default {
  data: () => ({
    groupUsers: [],
    groupUsersLoading: false,
    groupUsersRequest: 0,
  }),
  computed: {
    groupUsersKey() {
      if (!this.feedsGroupUsers || !this.ready) {
        return "";
      }
      return [this.selectedCompanyIds.join(","), this.from, this.to].join("|");
    },
    /** Propovi koje ekran sa radnicima dobija od ljuske. */
    groupUsersProps() {
      return { users: this.groupUsers, loading: this.groupUsersLoading };
    },
  },
  watch: {
    groupUsersKey: {
      handler() {
        this.loadGroupUsers();
      },
      immediate: true,
    },
  },
  methods: {
    async loadGroupUsers() {
      const requestId = ++this.groupUsersRequest;
      if (!this.groupUsersKey) {
        this.groupUsers = [];
        this.groupUsersLoading = false;
        return;
      }
      this.groupUsersLoading = true;
      try {
        const response = await reportService.getCompanyFoodKorisnici(this.selectedCompanyIds.join(","), {
          date: this.from,
          date2: this.to,
          without_orders: 1, // isti odgovor bez niza orders (brže); vreme narudžbe je u ordered_at
        });
        if (requestId === this.groupUsersRequest) {
          this.groupUsers = response.data?.users || [];
        }
      } catch (error) {
        if (requestId === this.groupUsersRequest) {
          this.groupUsers = [];
        }
      } finally {
        if (requestId === this.groupUsersRequest) {
          this.groupUsersLoading = false;
        }
      }
    },
  },
};
